import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import videoChatImage from '../../images/video-blk.png';
import injectSaga from '../../../../utils/injectSaga';
import injectReducer from '../../../../utils/injectReducer';
import videoChat from '../reducer';
import * as actions from '../actions';
import saga from '../sagas';
import { getCookie, getFlowType, getSession, viewport, getAPPID, isExpressCheckout, isMobile, isMVA } from '../../Helpers';
import TextLink from '../../TextLink';
import { StyledWrapper } from '../../styles';
import { getSecureBaseUrl } from '../../../../services/UrlMapperService';
import { store } from '../../../../configureStore';

let LQResponseData = getSession('LQResponse');
LQResponseData = JSON.parse(LQResponseData);
const sessionId = getCookie('digital_ig_session');
const zipCode = LQResponseData?.output?.zipCode;
const vzwDLGlobalID = '';
let isMVAChannel = false;
// const videoAssistUrl = '/soe/digital/mediaservice/getmediastats';
const isLTEFlow = false;
let loggedInMDN = '';
const isLoggedIn = getAPPID() === 'AAL';
if (isLoggedIn) {
  loggedInMDN = getSession('MTN');
}

// MTN
// digital_ig_session

const wrapperStyles = `
display: inline-block;
height: 20px;
font-size: ${isExpressCheckout() && (isMobile() || isMVA()) ? '12px' : '16px'};
img {
  width: 20px;
  height: ${isExpressCheckout() ? '12.5px' : '20px'};
  margin-right: 10px;
}
`;

class VideoChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isgetmediatriggered: false,
    };
  }

  componentDidMount() {
    const isPreOrder = false;
    const { pathname } = window?.location;
    if (!isLTEFlow && !isPreOrder && window.vzFlags?.enableVideoCall) {
      const videoAssistUrl = `${getSecureBaseUrl(true)}/mediaservice/getmediastats`;
      if (!pathname.includes('progressiveplan') && !pathname.includes('shipping')) {
        this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const isPreOrder = false;
    const existingState = store.getState();
    const { pathname } = window?.location;
    const timeOut = getSession('TimeOut');
    const progressivePlansPage = pathname?.includes('progressiveplan');
    const performanceFflag = existingState?.checkout?.getCheckoutResponse?.data?.featureFlags?.skipPageLoadFFlag || false;
    const skipPageLoadPh2FFlag = existingState?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.skipPageLoadPh2FFlag || false;
    if (!isLTEFlow && !isPreOrder && window.vzFlags?.enableVideoCall) {
      const videoAssistUrl = `${getSecureBaseUrl(true)}/mediaservice/getmediastats`;
      if (
        !this.state?.isgetmediatriggered &&
        ((performanceFflag && pathname.includes('shipping')) ||
          ((prevProps?.planDetails !== this.props?.planDetails || prevProps?.getcheckoutDetails !== this.props?.getcheckoutDetails) &&
            progressivePlansPage &&
            skipPageLoadPh2FFlag))
      ) {
        setTimeout(() => this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1), timeOut || 2000);
        this.setState({ isgetmediatriggered: true });
      } else if (
        !this.state?.isgetmediatriggered &&
        ((!performanceFflag && pathname.includes('shipping')) || (progressivePlansPage && !skipPageLoadPh2FFlag))
      ) {
        this.props.showVideoChatAssisAct(videoAssistUrl, sessionId, zipCode, this.props.showVideoChatAssist, 1);
        this.setState({ isgetmediatriggered: true });
      }
    }
  }

  handleVideoChatClick = (pageName) => {
    let width;
    // let height;
    let left = 0;
    if (window.innerWidth < 720) {
      width = window.innerWidth;
    } else {
      width = 700;
      left = (window.innerWidth - 700) / 3;
    }
    const height = window.innerHeight < 700 ? window.innerHeight : 700;
    const params = `width=${width},height=${height},top=20,left=${left}, resizable=no`;

    const videoChatUrl = `/stores/video-assist?z=${zipCode}&p=5G${pageName}&global=${vzwDLGlobalID}&mdn=${loggedInMDN}`;
    const pass = window.open(videoChatUrl, '_blank', params);
    pass.pageEntry = `5G ${pageName}`;
    pass.locationCode = zipCode;
  };

  isVideoDevTestEnabled = () => getSession('liveSupportDevTest') === 'Y' || getSession('videoSupportServiceDevTest') === 'Y';

  render() {
    const type = viewport();
    if (type === 'mfapp') {
      isMVAChannel = true;
    }
    const isRepavailable = this.props.showVideoChatAssist || this.isVideoDevTestEnabled();
    if (!isRepavailable || isMVAChannel || getFlowType() !== '5G') {
      return null;
    }
    return (
      <StyledWrapper className={isExpressCheckout() ? 'videoCallBlock_EC' : ''} styles={wrapperStyles} id="videoCallBlock">
        <img src={videoChatImage} alt="VideoChat" />
        <TextLink
          id="videoChatCol"
          data-analyticstrack="chat-click:video:icon"
          ariaLabel="Video Call"
          onClick={() => {
            this.handleVideoChatClick(this.props.title);
          }}
          isVideoChat
        >
          Video Call
        </TextLink>
      </StyledWrapper>
    );
  }
}

VideoChat.propTypes = {
  showVideoChatAssist: PropTypes.bool,
  showVideoChatAssisAct: PropTypes.func,
  title: PropTypes.string,
  planDetails: PropTypes.any,
  getcheckoutDetails: PropTypes.any,
};

const mapStateToProps = (state) => {
  const showVideoChatAssist = state?.videoChat?.showVideoChatAssist || false;
  const planDetails = state?.progressivePlans?.progressivePlanAPiResponse ? state?.progressivePlans?.progressivePlanAPiResponse : {};
  const shippingDetails = state?.shippingInfo?.ShippingInfoDetails ? state?.shippingInfo?.ShippingInfoDetails : {};

  const getcheckoutDetails = state.checkout?.shipment || {};

  return {
    showVideoChatAssist,
    planDetails,
    shippingDetails,
    getcheckoutDetails,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...actions,
    },
    dispatch,
  );
}

const withSaga = compose(injectSaga({ key: 'commonChat', saga }));

const withReducer = compose(injectReducer({ key: 'videoChat', reducer: videoChat }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withSaga, withReducer, withConnect)(VideoChat);
